import { call, put, takeEvery } from "redux-saga/effects"
import { MONITOR_TYPE_LOAD } from "./actionTypes"
import { monitorTypeError, loadTypes } from "./actions"
import service from "../../../api/type.service"

function* loadMonitorType(concept) {
  try {
    const response = yield call(service.getTypesByConceptCode, concept.payload)
    yield put(loadTypes(response?.data))
  } catch (error) {
    yield put(monitorTypeError(error.message))
  }
}

function* monitorTypeSaga() {
  yield takeEvery(MONITOR_TYPE_LOAD, loadMonitorType)
}

export default monitorTypeSaga
